/**
 * BitacoraApiClient -- HTTP client for /api/v1/bitacora.
 * Registro trazable de cambios, coordinacion entre agentes,
 * y log de deploys/intervenciones en el ecosistema Nexo.
 *
 * @module infrastructure/api/BitacoraApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/bitacora';

export const BitacoraApiClient = {
  /**
   * Lista anotaciones. `desde` es ISO en Z (BIT-PUB-T1, API 1.6.45): filtra
   * ts_utc >= desde y permite pedir hasta 500.
   *
   * FAIL-OPEN A PROPOSITO: hoy produccion corre 1.6.44 y IGNORA estos dos
   * parametros -- medido el 4-sep: pedir limit=500, since y hasta un parametro
   * inventado devuelve lo mismo, 200 con 100 items y la misma ventana de 12,8 h.
   * Asi que mandarlos no rompe nada, y el dia que 1.6.45 llegue a produccion
   * esta misma vista empieza a traer el dia completo SIN re-deploy. La etiqueta
   * de la pantalla dice siempre la ventana REAL que llego, asi que es cierta
   * antes y despues.
   */
  // `origen` filtra por quien escribio (igualdad exacta en la API: BitacoraService "origen = @Origen"; PROYECTOS-ALINEADOS-T1).
  async list(limit = 20, desde = null, origen = null) {
    const q = `${BASE}?limit=${limit}` + (desde ? `&since=${encodeURIComponent(desde)}` : '')
      + (origen ? `&origen=${encodeURIComponent(origen)}` : '');
    return ApiBase.get(q);
  },

  async create({ origen, titulo, notas, tareasOk, payload }) {
    return ApiBase.post(BASE, { origen, titulo, notas, tareasOk, payload });
  }
};
